import { render, staticRenderFns } from "./AddingBank.vue?vue&type=template&id=2beb1252&scoped=true&"
import script from "./AddingBank.vue?vue&type=script&lang=js&"
export * from "./AddingBank.vue?vue&type=script&lang=js&"
import style0 from "./AddingBank.vue?vue&type=style&index=0&id=2beb1252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb1252",
  null
  
)

export default component.exports